import React from 'react';
import ColorTag from '../ColorTag/ColorTag';

interface ColorTagCompletedProps {}

const ColorTagCompleted: React.FC<ColorTagCompletedProps> = props => {
  return <ColorTag className="ColorTagCompleted" color="green">Completed</ColorTag>
}

export default ColorTagCompleted;